import get from "lodash/get";

const BROWSERS = [
	{ id: "webkit", name: "WebKit" },
	{ id: "firefox", name: "Firefox" },
	{ id: "ie6", name: "MSIE 6" },
	{ id: "ie7", name: "MSIE 7" },
	{ id: "ie8", name: "MSIE 8" },
	{ id: "ie9", name: "MSIE 9" },
	{ id: "ie10", name: "MSIE 10" },
	{ id: "edge", name: "Edge" },
	{ id: "silk", name: "Silk" },
	{ id: "opera", name: "Opera" },
];
const WEBKIT_BROWSER_TYPES = [
	"chrome",
	"safari",
];

const SYSTEMS = [
	{ id: "mac", name: "Mac" },
	{ id: "windows", name: "Windows" },
	{ id: "linux", name: "Linux" },
];

const DEVICES = [
	{ id: "android", name: "Android" },
	{ id: "blackberry", name: "BlackBerry;" },
	{ id: "blackberry", name: "BB10;" },
	{ id: "iphone", name: "iPhone" },
	{ id: "ipod", name: "iPod" },
	{ id: "ipad", name: "iPad" },
	{ id: "windows", name: "Windows Phone" },
	{ id: "kindle", name: "Silk" },
];

/**
 * Extracts system, device, and browser information from a userAgent string.
 * This isn't a full re-implementation of BrowserInfo.pub + Browser.pub,
 * Just what we maybe need for now.
 * @param {string|null} userAgent - A userAgent string. Defaults to navigator.userAgent.
 * @returns {object} An object with system, device, and browser information.
 */
function getBrowserInfo(userAgent = get(window, "navigator.userAgent", "")) {
	const { id: system } = SYSTEMS.find(({ name }) => userAgent.includes(name)) || {};
	const { id: device } = DEVICES.find(({ name }) => userAgent.includes(name)) || {};
	const { id: browser } = BROWSERS.find(({ name }) => userAgent.includes(name)) || {};
	const webkitBrowserType = browser === "webkit" && WEBKIT_BROWSER_TYPES
		.find((browserName) => userAgent.toLowerCase().includes(browserName));

	return {
		system,
		device,
		browser,
		webkitBrowserType,
	};
}

export default getBrowserInfo;



// WEBPACK FOOTER //
// ./src/shared/util/getBrowserInfo.js